import React from 'react';
import { useNavigate } from 'react-router-dom';
import '../common.css'; // Import common CSS styles

function Read() {
    const navigate = useNavigate();

    function goToUserDetails() {
        navigate('/atsg/read/user_details');
    }
    function goToDeviceDetails() {
        navigate('/atsg/read/device_details');
    }
    function goToHome() {
        navigate('/atsg/home');
    }
    function goBack() {
        navigate(-1); // Navigate to the previous page
    }

    return (
        <>
            <div className="menu-box shadow-xl shadow-cyan-500/30">
                <div className="menu-title underline underline-offset-2">
                    <h2 align='center'>
                        Read Resource
                    </h2>
                    
                </div>
                
                <div className="center-box shadow-5xl shadow-cyan-500/30">
                    <button
                        onClick={goToUserDetails}
                        className={"center-button rounded-md shadow-xl shadow-cyan-500/30 w-48"}
                    >
                        Get User Details
                    </button>
                    <button
                        onClick={goToDeviceDetails}
                        className={"center-button rounded-md shadow-xl shadow-cyan-500/30"}
                    >
                        Get Device Details
                    </button>
                </div>
                <div className="foot-box">
                        <button
                            onClick={goBack}
                            className="foot-button"
                        >
                            Back
                        </button>
                        <button
                            onClick={goToHome}
                            className="foot-button"
                        >
                            Home
                        </button>
                </div>
            </div>
        </>
    );
}

export default Read;